import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'

export interface VirusDistributionReq {
  /** 开始时间，时间戳(秒) */
  start_time?: number
  /** 结束时间，时间戳(秒) */
  end_time?: number
}

export interface VirusDistributionRes {
  /** 风险类型列表 */
  threat_types: string[]
  /** 数量列表 */
  counts: number[]
}

@Injectable()
export class VirusDistributionChartService {
  constructor (private http: Http) {}

  @InvokeThrottle()
  getVirusDistribution (data: VirusDistributionReq) {
    return this.http.post<VirusDistributionRes>('/safemonitor/virus-scan/distribution', data)
  }
}

